import { EventListener } from "./utils/event-listener";

export class SnapEffectEventListener extends EventListener {}

const snapEffectEventListener = new SnapEffectEventListener();
export default snapEffectEventListener;
